import { useState, useContext, type MouseEvent } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { DialogIberiaContent, Dialog } from '../../../navigation/dialog/Dialog';
import { Link } from '../../../navigation/link/Link';
import { dataCheckBoxPrivacyStatement, dataCheckBoxInfo } from '../ApisForm.constants';
import { ApisFormContext } from '../ApisForm.utils';
import styles from '../components/CheckBoxInfo/CheckBoxInfo.module.css';
import { LiteralsDialog, LabelCheckBox, ModelGdpr } from '../ApisForm.model';
import { DialogIberiaInteractionType, DialogIberiaProps } from '../../../navigation';

export const UseCheckBoxInfo = () => {
	const { t } = useTranslation(['checkbox-info', 'common']);
	const [openDialog, setOpenDialog] = useState<boolean>(false);
	const [typeDialog, setTypeDialog] = useState<string | undefined>(undefined);
	const { isPrivacyStatement, isFormDisabled, gdpr } = useContext(ApisFormContext);
	const arrInputs = isPrivacyStatement ? [...dataCheckBoxPrivacyStatement, ...dataCheckBoxInfo] : dataCheckBoxInfo;
	const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault();
		setTypeDialog(e.currentTarget.id);
		setOpenDialog((prevState) => !prevState);
	};
	const handleModalUserInteraction = (type?: DialogIberiaInteractionType) => {
		switch (type) {
			case 'CANCEL':
			case 'CLOSE':
			case 'PRIMARY':
				setOpenDialog(false);
				break;

			default:
				break;
		}
	};
	const DialogLink = () => {
		const isUsPrivacy = typeDialog === 'CHECK_US_PRIVACY_ACT_STATEMENT';
		const args: DialogIberiaProps = {
			header: isUsPrivacy ? t('MODAL_US_PRIVACY_ACT_STATEMENT_TITLE') : t('common:DATA_PROCESSING'),
			body: GetTransDialog(isUsPrivacy),
			bodyAs: 'div',
			primaryButton: t('common:BTN_ACCEPT'),
			ariaLabelClose: 'This is a "close button"',
			onUserInteraction: handleModalUserInteraction
		};
		return (
			<Dialog open={openDialog}>
				<DialogIberiaContent {...args} />
			</Dialog>
		);
	};
	const GetTransLabel = (label: 'CHECK_US_PRIVACY_ACT_STATEMENT' | 'NOT_SEND_NEWSLETTER', i18nTrans = false) => {
		const isUsPrivacy = label === 'CHECK_US_PRIVACY_ACT_STATEMENT';

		if (isUsPrivacy)
			return (
				<Trans
					t={t}
					i18nKey={label}
					components={{
						span: <Link link="#" onClick={onClick} id={label} title="link" className={styles.textLink}></Link>
					}}
				/>
			);
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		else
			return (
				<Trans
					t={t}
					i18nKey="NOT_SEND_NEWSLETTER"
					components={{
						span: (
							<Link
								link="#"
								onClick={onClick}
								className={styles.textLink}
								titleLink={t('common:DATA_PROCESSING')}
								id={label}
								i18nTrans={i18nTrans}
							/>
						)
					}}
				/>
			);
	};
	const GetTransDialog = (isUsPrivacy: boolean) => {
		const literalsUsPrivacy: LiteralsDialog[] = [
			'MODAL_US_PRIVACY_ACT_STATEMENT_BODY_P1',
			'MODAL_US_PRIVACY_ACT_STATEMENT_BODY_P2',
			'MODAL_US_PRIVACY_ACT_STATEMENT_BODY_P3'
		];

		if (isUsPrivacy)
			return literalsUsPrivacy.map((literal: LiteralsDialog, index: number) => {
				return (
					<Trans
						key={index}
						t={t}
						i18nKey={literal}
						components={{
							p: <p className={styles.textP} key={`${index.toString()}-p`}></p>,
							bold: <span className={styles.textBold} key={`${index.toString()}-span`}></span>
						}}
					/>
				);
			});
		return TransGdpr(gdpr as ModelGdpr);
	};
	const getLabel = (i18nTrans: boolean, label: LabelCheckBox): React.ReactNode => {
		if (i18nTrans) return GetTransLabel(label as 'CHECK_US_PRIVACY_ACT_STATEMENT' | 'NOT_SEND_NEWSLETTER', i18nTrans);
		return t(label);
	};
	const TransGdpr = ({ text, url }: ModelGdpr) => {
		const parser = new DOMParser();
		const doc = parser.parseFromString(text, 'text/html');
		const linkElement = doc.querySelector('a');

		const newUrl = url;
		const className = styles.textLink;

		return (
			<div>
				{doc.body.textContent}{' '}
				<a href={newUrl} className={className} target="__blank" title={linkElement?.textContent ?? ''}>
					{linkElement?.textContent}
				</a>
			</div>
		);
	};

	return {
		t,
		openDialog,
		isFormDisabled,
		arrInputs,
		DialogLink,
		getLabel
	};
};
